// src/services/settingsService.js
import api from './api';

export const settingsService = {
  // Application Settings
  getApplicationSettings: async () => {
    try {
      console.log('🔧 Fetching application settings...');
      const response = await api.get('/Settings/application');
      console.log('✅ Application settings loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching application settings:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to load application settings');
    }
  },

  updateApplicationSettings: async (settings) => {
    try {
      console.log('🔧 Updating application settings...', settings);
      const response = await api.post('/Settings/application', settings);
      console.log('✅ Application settings updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating application settings:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to update application settings');
    }
  },

  // File Uploads
  uploadLogo: async (file) => {
    try {
      console.log('🖼️ Uploading logo...', file.name);
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/Settings/upload-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('✅ Logo uploaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error uploading logo:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to upload logo');
    }
  },

  uploadFavicon: async (file) => {
    try {
      console.log('🎯 Uploading favicon...', file.name);
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('/Settings/upload-favicon', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('✅ Favicon uploaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error uploading favicon:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to upload favicon');
    }
  },

  // Options
  getThemeOptions: async () => {
    try {
      console.log('🎨 Fetching theme options...');
      const response = await api.get('/Settings/themes');
      console.log('✅ Theme options loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching theme options:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to load theme options');
    }
  },

  getLanguageOptions: async () => {
    try {
      console.log('🌐 Fetching language options...');
      const response = await api.get('/Settings/languages');
      console.log('✅ Language options loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching language options:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to load language options');
    }
  },

  getTimezoneOptions: async () => {
    try {
      console.log('⏰ Fetching timezone options...');
      const response = await api.get('/Settings/timezones');
      console.log('✅ Timezone options loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching timezone options:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to load timezone options');
    }
  },

  // System Operations
  resetToDefaults: async () => {
    try {
      console.log('🔄 Resetting settings to defaults...');
      const response = await api.post('/Settings/reset-to-defaults');
      console.log('✅ Settings reset:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error resetting settings:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to reset settings');
    }
  },

  getSystemInfo: async () => {
    try {
      console.log('💻 Fetching system info...');
      const response = await api.get('/Settings/system-info');
      console.log('✅ System info loaded:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching system info:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
      throw new Error(error.response?.data?.message || 'Failed to load system information');
    }
  }
};